export default __webpack_public_path__ + "437c965311628f3be5484f4c18d9318a.png";